<template>
  <div id="app">
    <MainNav></MainNav>
    <div class="main-content">
      <transition name="fade" mode="out-in">
 <router-view style="animation-duration: .7s"></router-view>
</transition>

    </div>
    <MainFooter></MainFooter>
  </div>
</template>

<script>

import MainNav from './components/MainNav.vue'
import MainFooter from './components/MainFooter.vue'
import FontAwesome from '../static/css/fontawesome/fontawesome.min.css'


export default {
  components: {
    MainNav, MainFooter
  },
  data () {
    return {

    }
  },
  methods: { 
    scrollToTop() {
      window.scrollTo(0,0);
    },
               consoleLogMe: function () {
            console.log('logggggggggggged')
           }
  }
}

</script>






<style lang="scss">
@import './styles/main.scss';

@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css');


$font-stack:    Helvetica, sans-serif;
$primary-color: black;

body {
  font: 100% $font-stack;
  background-color: $primary-color;
}

$animationDuration: 0.2s; // specify animation duration. Default value: 1s


@import url('https://fonts.googleapis.com/css?family=Poppins|Teko:400,700');

body {
  margin:0px;

}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  height:100%;
  width:100%;
  position:absolute;

}

.main-content {
    padding-top: 50px;
}

.background-pattern {
    background-image: url(https://t3.ftcdn.net/jpg/01/04/46/88/240_F_104468854_qSQs8E4nruOVssnDMYXUvuEhgvMa9OTp.jpg);
    height: 200px;
    width: 100%;
    position: absolute;
    opacity: .02;
    background-size: 4%;
}

.year-top-image > img {
  width:100%;
  display:block;
}

.img-50w {
  width:50%;
}

.img-100w{
  width:100%;
}


.year-summary-wrapper {
    position: relative;
    border-bottom: 7px solid #000;

}

.year-summary {
    margin: 0px;
    padding: 60px 20px;
    font-family: 'Poppins', sans-serif;
}

.triangle-top-left {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 191px 41px 0 0;
    border-color: #000000 transparent transparent transparent;
    position: absolute;
}

.triangle-bottom-right {
width: 0;
height: 0;
border-style: solid;
border-width: 0 0 191px 41px;
border-color: transparent transparent #000 transparent;
    position: absolute;
    bottom:0;
    right:0;
}


.content-headline {
      width: 100%;
    margin: 0px 0px;
    font-family: 'Teko', sans-serif;
    transform: skewX(-12deg);
    line-height: 72px;
    font-size: 70px;
    text-transform: uppercase;
}

.content-headline {
    line-height: 67px;
    font-size: 74px;
  }

.year-summary-text-flex {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    max-width: 1420px;
    margin: 0 auto;
}

.year-summary-text-flex p {
    width: 45%;
    margin-bottom: 0px;
    margin-top: 20px;
    font-size:18px;
    line-height:26px;
}

.copy-paragraph {
    width: 45%;
    margin-bottom: 0px;
    margin-top: 20px;
    font-size: 18px;
    line-height: 26px;
}


.year-summary-text-flex p:nth-of-type(odd) {
    margin-right: 60px;
}



.copy-paragraph:nth-of-type(odd) {
    margin-right: 60px;
}



.year-summary-text-flex p.image-paragraph {
  /* margin-top:0px; */
}


span.blockquote {
    font-size: 60px;
    font-family: 'Teko', sans-serif;
    display: block;
    line-height: 53px;
    margin: 20px auto;
    text-transform: uppercase;
    position: relative;
    padding-right: 40px;
    text-align: right;
    transform: skewX(-12deg);
    width: 70%;
}

span.blockquote:after {
    content: "-";
    background: #D3BC8D;
    color: #D3BC8D;
    display: inline-block;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
}



.fact-wrapper {
  background-color:#fff7e6;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  padding: 20px 20%;
}
.fact-headline {
  color:#000000;
  font-family: 'Teko';
  font-size:20px;
  text-align:center;
  line-height:20px;
  text-transform:uppercase;
  margin-bottom: 15px;
}

.fact-sub-headline {
  font-size:12px;
  margin-top:-15px;
  margin-bottom:15px;
  font-family: 'Poppins'
}
.fact-content {
  font-family: 'Poppins';
  font-size:12px;
}

.flex-table-wrapper {
  display:flex;
  flex-wrap:wrap;
  width:100%;
  font-family: 'Poppins';
}

.flex-table-row {
    display: flex;
    width: 100%;
    text-align: center;
    border-bottom: 2px dotted #e8e0d1;
    min-height: 25px;
    justify-content: center;
    align-items: center;
  min-height:35px;
}

.flex-table-header {
  border:none;
  font-weight:700;
  background-color: #d3bc8c;
}

.flex-table-header .flex-table-cell span {
  background:#d3bc8c;
  border-radius:2px;
  padding:3px 3px;
}

.flex-table-cell {
  flex:2;
    flex: 2;
    font-size: 12px;
    line-height: 16px;
}

.flex-table-cell:nth-of-type(1) {
  flex:3;
    font-weight:700;
}
.flex-table-cell:nth-of-type(2) {
  flex:2;
}

@media (min-width:768px) {
  .fact-headline {
    font-size: 50px;
    line-height: 50px;
    margin-bottom: 15px;
}
  
  .flex-table-cell {
  flex:2;
  font-size: 18px;
  line-height: 24px;
}
}






@media (max-width:1500px) {

.year-summary-text-flex {
    max-width: 1060px;
}

  .img-50w {
  width:100%;
}

.content-headline {
    width: 80%;
    padding: 0px 30px;
}

.fact-wrapper {
  padding: 20px 10%;
}


}

@media (max-width:768px) {
  .year-summary-text-flex p {
    font-size: 16px;
}

.copy-paragraph {
    font-size: 15px;
    line-height: 20px;
}

.fact-wrapper {
  padding: 20px 15px;
}

}



@media (max-width:767px) {
  .year-summary-text-flex {
  flex-direction:column;
  }
  .year-summary-text-flex p {
    width: 100%;
  }
  .copy-paragraph {
    width: 100%;
}
  .content-headline {
    line-height: 49px;
    font-size: 50px;
  }
    .year-main-content {
  margin-top:35px;
  }


.copy-paragraph:nth-of-type(odd) {
    margin-right: 0px;
}


#nav-main>a {
    font-size: 17px;
    margin: 12px;
}

#nav-main>a>img {
    height: 25px;
    margin-right: 4px;
}

}

@media (max-width:420px) {




  .year-summary-text-flex p {
   font-size:15px;
  }
  .content-headline {
     line-height: 31px;
    font-size: 36px;
  }

span.blockquote {
    font-size: 35px;
    line-height: 35px;
    margin: 20px auto;
    padding-right: 30px;
    width: 85%;
}

.flex-table-cell:first-of-type {
    flex: 6;
}

.flex-table-row {
    min-height: 40px;
}



}

@media (max-width:374px) {
  div#nav-main>a {
    font-size: 12px;
}
div#nav-main>a>img {
    height: 18px;
    margin-right: 3px;
}
}

</style>



// WEBPACK FOOTER //
// src/App.vue